import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

const useInvoiceActionState = createGlobalState(() => {
  const mode = ref<'' | 'new-invoice'>('');
  return { mode };
});

export default useInvoiceActionState;
